import { debounce } from 'es-toolkit';
import compareUrls from 'compare-urls';
import { type MarketCountryCode, type SearchListingsFilters, type SearchListingsOptions } from '@ev-tech/search-modules-api';

import { createSerpUrl } from './createSerpUrl';
import { type AdditionalUiStateParams } from '../types/types';

type NextHistoryState = {
  __N: true;
  key: string;
  url: string;
  as: string;
  options: { shallow?: boolean };
};

type UpdateUrlParams = {
  filters: SearchListingsFilters;
  options: SearchListingsOptions;
  countryCode: MarketCountryCode;
  onUrlUpdate?: (url: string) => void;
  willSyncStateWithUrl?: boolean;
} & AdditionalUiStateParams;

export const updateUrl = ({ filters, options, countryCode, onUrlUpdate, willSyncStateWithUrl, ...additionalParams }: UpdateUrlParams) => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = createSerpUrl({
    filters,
    options: {
      countryCode,
      language: options.language,
      currency: options.currency,
      measurementSystem: options.measurementSystem,
      page: options.page,
    },
    additionalParams,
  });

  if (compareUrls(window.location.href, url.href)) return;

  if (onUrlUpdate) onUrlUpdate(url.href);

  if (willSyncStateWithUrl) {
    const historyState: NextHistoryState = {
      url: url.href,
      as: url.href,
      options: { shallow: true },
      __N: true, // indicates that this is a Next.js history state so the next-router will handle restoring the page
      key: Math.random().toString(36).slice(2, 10),
    };
    window.history.pushState(historyState, '', url.href);
  }
};

export const debouncedUpdateUrl = debounce(updateUrl, 50);
